import useSWR from 'swr';

import { fetchLineupCamLog } from 'common/api/lineupCamLog';
import type { LineupCamLogEntry } from 'common/api/lineupCamLog';

interface UseLineupCamLogResult {
  focusPolygon: LineupCamLogEntry['focusPolygon'] | null;
  overviewCameraId: string | null;
  isLoading: boolean;
}

export const useLineupCamLog = (lineupCameraId: string | null): UseLineupCamLogResult => {
  const { data, isLoading } = useSWR(
    lineupCameraId ? ['lineup-cam-log', lineupCameraId] : null,
    ([, id]) => fetchLineupCamLog(id),
    { revalidateOnFocus: false, revalidateOnReconnect: false, errorRetryCount: 0 },
  );

  return {
    focusPolygon: data?.focusPolygon ?? null,
    overviewCameraId: data?.overviewSmartCameraId ?? null,
    isLoading: !!lineupCameraId && isLoading,
  };
};
